import { Link } from 'react-router-dom';
import { useReveal } from '@/hooks/useReveal';
import SectionHeader from '@/components/ui/SectionHeader';
import { DUAL_ENTRY } from '@/data/mockData';
import s from './DualEntry.module.scss';

// ── 이중 진입 (D안 Phase 2-①, 2026-09) ───────────────────────────────
//   Hero 아래 신규 섹션. 방문자가 '제품 축(제품으로 찾기)' / '안전·환경 축(도메인으로 찾기)'
//   두 갈래 중 자기 방식대로 진입. D안 핵심 신규 요소(대기업 이중축 방식).
//   모션: 기존 evs.com/as 리빌 철학 계승 — useReveal(부모 진입) + 자식 .anim-scroll 노출.
//   ★링크: 2026-09-08 라우트 재편으로 실연결 — 제품→/products · 안전→/safety · 환경→/environment.
//     SPA 이동(react-router Link). (과거 '#' 미연결 → 3 기본 페이지 생성으로 해소.)
//   ★아이콘(2026-09-05→09-08 갱신): 2카드→3카드로 분리됨에 따라 기존 'domain'(방패+공기) 단일 아이콘을
//     'safety'(방패=산업안전) · 'environment'(잎=대기환경) 둘로 분화.
//     색 = [2026-09-08] 도메인 구분자 색 체계와 통일 — 제품=시안 2톤 / 안전=시안(방패) / 환경=그린(잎).
//       '색은 구분자' 원칙([[evs-page-ux-standards]] 절제)과 일치: 안전=시안 #00AEEF, 환경=그린 #35c17e.
//     형태 참고 소스 3사이트(flaticon/allsvgicons/iconbuddy)는 '모양'만 참고, 색은 사이트 톤.
const CARD_ICON: Record<string, JSX.Element> = {
  // 제품으로 찾기 = 2×2 그리드(제품 카탈로그). 대각 시안/연시안 체커로 플랫 2톤.
  product: (
    <svg className={s.icon} viewBox="0 0 48 48" aria-hidden="true">
      <rect x="7" y="7" width="15" height="15" rx="3.5" fill="#00AEEF" />
      <rect x="26" y="7" width="15" height="15" rx="3.5" fill="#BDE9FA" />
      <rect x="7" y="26" width="15" height="15" rx="3.5" fill="#BDE9FA" />
      <rect x="26" y="26" width="15" height="15" rx="3.5" fill="#00AEEF" />
    </svg>
  ),
  // 안전으로 찾기 = 방패(산업안전보건). 시안 방패 + 흰 체크 컷아웃.
  safety: (
    <svg className={s.icon} viewBox="0 0 48 48" aria-hidden="true">
      <path fill="#00AEEF" d="M24 4 40 9.6V20c0 9.3-6.6 17.3-16 21-9.4-3.7-16-11.7-16-21V9.6Z" />
      <path fill="none" stroke="#fff" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round"
        d="m17 23 5 5 9-10" />
    </svg>
  ),
  // 환경으로 찾기 = 잎(대기환경). 그린 2톤 잎 + 연그린 잎맥.
  environment: (
    <svg className={s.icon} viewBox="0 0 48 48" aria-hidden="true">
      <path fill="#35c17e" d="M38 8c-16 0-27 7-27 21 0 4 1.4 7.4 3.6 10C20 30 27 24 36 21c-7 4-12 10-16 18 12 2 22-6 22-19 0-4-1-8-4-12Z" />
      <path fill="none" stroke="#BEEBD4" strokeWidth="2.2" strokeLinecap="round" d="M17 39C24 26 30 20 38 16" />
    </svg>
  ),
};

export default function DualEntry() {
  const reveal = useReveal<HTMLDivElement>();
  return (
    <section className={s.section}>
      <div className={s.inner} ref={reveal}>
        <SectionHeader title={DUAL_ENTRY.title} className="anim-scroll" />
        <div className={s.grid}>
          {DUAL_ENTRY.cards.map((c) => (
            <Link
              key={c.key}
              to={c.to}
              className={`${s.card} anim-scroll`}
            >
              {CARD_ICON[c.key]}
              <span className={s.label}>{c.label}</span>
              <span className={s.desc}>{c.desc}</span>
              <svg className={s.arrow} width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
                <path d="M7 17L17 7M17 7H9M17 7v8" />
              </svg>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
